//密码6-18位 字母、数字、特殊字符（包含两种）
export const checkPassword = (password) => {
  if (password.length < 8 || password.length > 18) {
    return false;
  }
  const hasLetter = /[a-zA-Z]/.test(password);
  const hasDigit = /\d/.test(password);
  const hasSpecialChar = /[`~!@#$%^&*()\-_=+;:'",<.>/?]/.test(password);
  const conditions = [hasLetter, hasDigit, hasSpecialChar];
  return conditions.filter(Boolean).length >= 3;
};

//验证群号正则 ： 非0开头的6-10 为纯数字
export const checkGroupNumber = (groupNumber) => {
  return /^[1-9]\d{5,10}$/.test(groupNumber);
};

//验证IM号正则 ： 非0开头的8位纯数字
export const checkIMNumber = (iMNumber) => {
  return /^[1-9]\d{7}$/.test(iMNumber);
};

//邮箱正则
export const checkEmail = (email) => {
  return /^[A-Za-z0-9]+([-._][A-Za-z0-9]+)*@[A-Za-z0-9]+(-[A-Za-z0-9]+)*(\.[A-Za-z]{2,6}|[A-Za-z]{2,4}\.[A-Za-z]{2,3})$/.test(email);
};

//手机号正则
export const checkPhone = (phone) => {
  return /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(17[013678])|(18[0,5-9])|(199))\d{8}$/.test(phone);
};

/**
 * 合法名称校验，不为空，且首尾不含空白字符
 * @param name
 * @return {boolean} 通过返回true
 */
export const legalNickname = function (name) {
  return name && /^[^\s].*/.test(name) && /.*[^\s]$/.test(name) && !/\s{2}/.test(name);
};

/**
 * 合法web url资源校验
 * @param url
 * @returns {boolean} 通过true
 */
export const legalWebUrl = (url) => {
  return url ? /^(http:\/\/|https:\/\/|www\.|\/\/)?[^./\s]+(\.[^./\s]+)+(\/\S+)+/.test(url) : false;
};



// WEBPACK FOOTER //
// ./src/js/utils/regular.js